import { ObservableArray, View } from "binder"
import { AccessManagementViewModel, FormViewModel, UserViewModel } from "./accessManagement-viewModel"

export class AccessManagementView extends View<AccessManagementViewModel>{
    GetViewUniqueId(): string {
        return "V-D30406FE-1C46-4179-912E-AA2A60F3DCF4"
    }
    loadHtml(): string {
        let element = require('./accessManagement.html').default;
        let style = require('./accessManagement.less');
        return element;
    }
    constructor() {
       super();
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set users(v: ObservableArray<UserViewModel>) { this._users = v; } public get users(): ObservableArray<UserViewModel> { return this._users;} private _users: ObservableArray<UserViewModel>;
    public set forms(v: ObservableArray<FormViewModel>) { this._forms = v; } public get forms(): ObservableArray<FormViewModel> { return this._forms;} private _forms: ObservableArray<FormViewModel>;

    refresh(){
        this.dataContext.refresh();
    }

    save(){
        this.dataContext.save()
    }
}
